var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.283,
    height: 18.018,
    viewBox: "0 0 18.283 18.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#91919c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.8,6.6a.914.914,0,0,0,.649-.265L18.19,3.588l-1.3-1.3L14.8,4.393,13.619,3.2l-1.3,1.3,1.828,1.828A.914.914,0,0,0,14.8,6.6ZM17.541,18.48V8.424a.914.914,0,0,0-.914-.914H12.97a.914.914,0,0,0-.914.914V18.48H10.227V13.909a.914.914,0,0,0-.914-.914H5.657a.914.914,0,0,0-.914.914V18.48H2v1.828H20.283V18.48ZM6.2,11.925l1.289-1.3,1.289,1.3,1.3-1.3-1.3-1.289,1.3-1.289-1.3-1.3-1.289,1.3L6.2,6.751l-1.3,1.3L6.2,9.338,4.9,10.627Z",
    transform: "translate(-2 -2.29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluate);
export default __webpack_public_path__ + "static/media/evaluate.1ec4d4098736c3d5f20bffdd6e020f5b.svg";
export { ForwardRef as ReactComponent };